import * as React from "react";
import { useState } from "react";
import { useUIFacade } from "../../../../../../../ui/facades/ui.facade";
import DateTemplate from "../../../../../../../ui/templates/columns/DateTemplate";
import LinkTemplate from "../../../../../../../ui/templates/columns/LinkTemplate";
import PrwcDataTableBasic from "../../../../../../../ui/widgets/custom/PrwcDataTableBasic";

const BusinessHours = () => {
  const [expandedRows, setExpandedRows] = useState([]);
  const uiFacade = useUIFacade();

  const handleOnDelete = (event: any, rowData: any) => {
    uiFacade.showConfirmDeletePopup(event, rowData, deleteBusinessHour);
  };

  const handleOnEdit = (rowData: any) => {
    console.log(rowData);
  };

  const deleteBusinessHour = (rowData: any) => {
    console.log('deleteBusinessHour called ---');
    console.log(rowData);
  }

  const actionTemplate = (rowData: any) => {
    return (
      <div className="flex">
        <i
          className="mr-1 text-xs cursor-pointer pi pi-trash"
          onClick={(e: any) => handleOnDelete(e, rowData)}
        ></i>
        <i
          className="text-xs cursor-pointer pi pi-pencil"
          onClick={(e: any) => handleOnEdit(rowData)}
        ></i>
      </div>
    );
  };

  const headerTemplate = (data: any) => {
    return <span className="text-xs font-semibold">{data.day}</span>;
  };

  const footerTemplate = (data: any) => {
    return <React.Fragment></React.Fragment>;
  };

  const data = [
    {
      id: 0,
      day: "Monday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 1,
      day: "Monday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 0,
      day: "Monday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 1,
      day: "Monday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 2,
      day: "Tuesday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 3,
      day: "Tuesday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 4,
      day: "Wednesday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 5,
      day: "Wednesday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 4,
      day: "Thursday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 5,
      day: "Thursday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 6,
      day: "Friday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 7,
      day: "Friday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 6,
      day: "Friday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 7,
      day: "Friday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 8,
      day: "Saturday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 9,
      day: "Saturday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 10,
      day: "Sunday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    },
    {
      id: 11,
      day: "Sunday",
      startTime: "10-3-2021",
      endTime: "20-4-2021",
      validFrom: "15-3-2021",
      validTo: "25-4-2021",
    }
  ];

  const dataTable = {
    columns: [
      {
        field: "day",
        headerLabelKey: "userCategories.label.day",
        bodyTemplate: LinkTemplate,
        className: "w-16 text-xs font-semibold text-blue-700",
      },
      {
        field: "startTime",
        headerLabelKey: "userCategories.label.startTime",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
      },
      {
        field: "endTime",
        headerLabelKey: "userCategories.label.endTime",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
      },
      {
        field: "validFrom",
        headerLabelKey: "userCategories.label.validFrom",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
      },
      {
        field: "validTo",
        headerLabelKey: "userCategories.label.validTo",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
      },
      {
        field: "action",
        bodyTemplate: actionTemplate,
        className: "w-6 text-xs",
      },
    ],
  };

  return (
    <div>
      <PrwcDataTableBasic
        data={data}
        columns={dataTable.columns}
        rowGroupMode="subheader"
        groupField="day"
        rowGroupHeaderTemplate={headerTemplate}
        rowGroupFooterTemplate={footerTemplate}
        expandableRowGroups
        expandedRows={expandedRows}
        onRowToggle={(e: any) => setExpandedRows(e.data)}
      ></PrwcDataTableBasic>
    </div>
  );
};

export default BusinessHours;
